import { LightErrorPopup as BaseErrorPopup } from '../../baseComponents/LightErrorPopup/LightErrorPopup';
import { withReduxState } from '../Modal/ModalWithRedux';

export const LightErrorPopup = withReduxState(BaseErrorPopup);
